module.exports = __webpack_public_path__ + "static/media/ic_payment_arrow.55609299.svg";